import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelServiceContext ,ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLOutOfSequenceConflictComponent } from 'ml-components-common-react';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLPublicContactsService } from 'gw-capability-quoteandbind';
import appConfig from 'app-config';
import { MLEndorsementFlowUtil, MLEndorsementUtil } from 'ml-portals-util-js';
import { MLTagManagerService } from 'ml-portals-services-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import AdditionalInterestListComponent from '../../../gw-capability-quoteandbind-common-react/components/AdditionalInterestListComponent/AdditionalInterestListComponent';

import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import metadata from './InterestedPartiesPage.metadata.json5';
import messages from './InterestedPartiesPage.messages';
import { ScrollToError } from '@jutro/legacy/wizard-next';

const HO_ADDITIONAL_INTERESTS_PATH = 'lobData.homeowners.coverables.additionalInterests';
const PA_ADDITIONAL_INTERESTS_PATH = 'lobData.personalAuto.coverables.vehicles.children';
const PUP_ADDITIONAL_INTERESTS_PATH = 'lobData.personalUmbrella.coverables.additionalInterests';
const HO_ADDITIONAL_INTEREST_SUBTYPE = 'HOPDwellAddlInterest';
const PA_ADDITIONAL_INTEREST_SUBTYPE = 'PAVhcleAddlInterest';
const PUP_ADDITIONAL_INTEREST_SUBTYPE = 'PUPLineAddlInterest_ML';
const CONTACT_SUBTYPE_COMPANY = 'Company';


function VehicleAdditionalInterestsComponent(props) {
    const translator = useTranslator();
    const { 
        path,
        vehicleVM,
        updateViewModel,
        onValueChange,
        initialPotentialContact,
        showValidationErrors,
        onValidate,
        isHOLine,
        isPersonalUmbrella,
        potentialContactsLoading,
        index,
        currentStepName,
        endorsementVM,
        additionalInterestAvailableCandidatesML
    } = props;

    return (
        <div id="vehicleInfoContainer" className="summary-header">
            <div id="vehicleIconContainer" className="summary-header__icon short">
                <span id="vehcileIcon" className="icon-ml-car-icon-outline" />
            </div>
            <div id="vehicleDetails" className="summary-header__content  vertical-spacing-20">
                <div id="vehicleCount" className="summary-header__count-text">
                    <span id="vehiclex">{translator(messages.vehicleX, { vehicleIndex: (index + 1) })}</span>
                </div>

                <div id="vehicleModel" className="summary-header__item-title">
                    <span id="yearMake" className="font-weight-bold">{`${vehicleVM.year.value} ${vehicleVM.make.value} `}</span>
                    <span id="modelTrim">{`${vehicleVM.model.value} ${vehicleVM.trim_ML.value}`}</span>
                </div>
            </div>
            <AdditionalInterestListComponent 
                id="paAdditionalInterest"
                path={path} 
                model={vehicleVM.additionalInterests}
                updateViewModel={updateViewModel}
                onValueChange={onValueChange}
                initialPotentialContact={initialPotentialContact}
                showValidationErrors={showValidationErrors}
                onValidate={onValidate}
                isHOLine={isHOLine}
                isPersonalUmbrella={isPersonalUmbrella}
                potentialContactsLoading={potentialContactsLoading}
                currentStepName={currentStepName}
                endorsementVM={endorsementVM}
                additionalInterestAvailableCandidatesML={additionalInterestAvailableCandidatesML}
            />
        </div>
        
    );
}

function InterestedPartiesPage(props) {
    const {
        wizardData,
        goNext,
        updateWizardData,
        currentStep,
        steps,
        currentStepIndex,
        changeNextSteps
    } = props;

    const {
        onValidate
    } = useValidation('InterestedPartiesPage');
    const { submissionVM } = wizardData;
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { EndorsementService } = useDependencies('EndorsementService');
    const hoAdditionalInterests = _.get(submissionVM, HO_ADDITIONAL_INTERESTS_PATH, undefined);
    const pupAdditionalInterests = _.get(submissionVM, PUP_ADDITIONAL_INTERESTS_PATH, undefined);
    const vehicles = _.get(submissionVM, PA_ADDITIONAL_INTERESTS_PATH, []);
    const isOOSConflict = _.get(submissionVM, 'isOutOfSequenceConflict_ML.value');
    const viewModelService = useContext(ViewModelServiceContext);
    const [potentialContacts, updatePotentialContacts] = useState([]);
    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [potentialContactsLoading, updatePotentialContactsLoading] = useState(true);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);
    const isPersonalAuto = submissionVM.value.isPersonalAuto();
    const isHomeowners = submissionVM.value.isHomeOwners();
    const isRenters = submissionVM.value.isRenters();
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isAgent = appConfig.portalCode === 'GPA';
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const addressVM = submissionVM.baseData?.policyAddress;

    const coveragePartTypeML = _.get(
        submissionVM,
        'lobData.homeowners.coverables.coveragePartType_ML.value.code'
    );

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const getAdditionalInterests = useCallback(() => {
        if (isHomeowners) {
            return hoAdditionalInterests;
        }
        return pupAdditionalInterests;
    }, [hoAdditionalInterests, isHomeowners, pupAdditionalInterests]);


    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Interested Parties Screen'}, submissionVM, authHeader)
    }, [])
    
    useEffect(() => {
        MLPublicContactsService.getMortgageeContacts(authHeader).then((data) => {
            updatePotentialContacts(data);
        }).finally(() => updatePotentialContactsLoading(false));

        EndorsementService.getAdditionalInterestCandidatesML(submissionVM.jobID.value, authHeader).then((candidates) => {
            setAdditionalInterestAvailableCandidatesML(candidates);
        });


        const clonedSubmissionVM = viewModelService.clone(submissionVM);
        if (isPersonalAuto) {
            _.set(clonedSubmissionVM, 'lobData.personalAuto.coverables.addInterestTypeCategory', PA_ADDITIONAL_INTEREST_SUBTYPE);
        } else if (isHomeowners) {
            _.set(clonedSubmissionVM, 'lobData.homeowners.coverables.addInterestTypeCategory', HO_ADDITIONAL_INTEREST_SUBTYPE);
        } else {
            _.set(clonedSubmissionVM, 'lobData.personalUmbrella.coverables.addInterestTypeCategory', PUP_ADDITIONAL_INTEREST_SUBTYPE);
        }

        const vehicleValues = _.get(clonedSubmissionVM, 'lobData.personalAuto.coverables.vehicles.value');
        if (vehicleValues) {
            vehicleValues.forEach((elem) => {
                elem.makeAddlInfoReq_Ext = true;

                const additionalInterests = _.get(elem, 'additionalInterests', []);
                additionalInterests.forEach((el) => {
                    el.exists = true;
                });
            });
        }

        const additionalInterests = getAdditionalInterests();
        if (additionalInterests && additionalInterests.value) {
            additionalInterests.value.forEach((elem) => {
                elem.exists = true;
            });
            if (isHomeowners) {
                _.set(clonedSubmissionVM, HO_ADDITIONAL_INTERESTS_PATH, additionalInterests.value)
            } else {
                _.set(clonedSubmissionVM, PUP_ADDITIONAL_INTERESTS_PATH, additionalInterests.value)
            }
        }

        updateWizardSubmissionData(clonedSubmissionVM);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Interested Parties Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAutoInterests = useCallback(() => {
        const autoInterests = [];

        vehicles.forEach((vehicle) => {
            vehicle.value.additionalInterests.forEach((el) => {
                autoInterests.push(el);
            });
        });

        return autoInterests;
    }, [vehicles]);

    const getContactDetails = (item) => {
        if (item.policyAdditionalInterest.subtype === CONTACT_SUBTYPE_COMPANY) {
            return item.policyAdditionalInterest.contactName ? item.policyAdditionalInterest.contactName : undefined;
        }
        return item.policyAdditionalInterest.firstName && item.policyAdditionalInterest.lastName ? 
            `${item.policyAdditionalInterest.firstName} ${item.policyAdditionalInterest.lastName}` : undefined;
    };

    const hasNamedNonOwner = useCallback(() => {
        if (isPersonalAuto) {
            return submissionVM.lobData.personalAuto.value.hasNamedNonOwner();
        }
        return false;
    },[isPersonalAuto, submissionVM.lobData.personalAuto.value]);

    const onNext = useCallback(() => {
        if (submissionVM.aspects.valid && submissionVM.aspects.subtreeValid) {
            const lbl = MLEndorsementUtil.stepLabel(currentStep);
            MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);
            const additionalInterests = getAdditionalInterests();
            const items = additionalInterests ? additionalInterests.value.filter((aInt) => aInt) : getAutoInterests();
            const dynamicSteps = MLNavigationStepsTrackingService.getData() ? MLNavigationStepsTrackingService.getData().dynamicSteps : undefined;

            // Remove "Add" or "Edit" prefix and normalize
            const normalizeDisplayName = (name = "") => name.toLowerCase().replace(/^(add|edit)\s+/, "").trim();
            // Map dynamic step type -> normalized navigation display name
            const typeMap = {
                TRUST_ML: "trust",
                ADDITIONALINSURED_ML: "additional insured",
                additional_interest_ml: "additional interest",
                thirdparty_ml: "third party",
            };
            // Build lookup from navigationData
            const navMap = dynamicSteps.reduce((acc, nav) => {
                const key = normalizeDisplayName(nav.displayName);
                // If both Add and Edit exist for same type,
                // Edit will overwrite Add (change logic if needed)
                acc[key] = nav.id;
                return acc;
            }, {});
            // Update dynamicSteps with matching id
            const updatedItems = items.map(step => ({
                ...step,
                id: navMap[typeMap[step.type]] || null,
            }));

            updatedItems.forEach((item) => {
                const details = {
                    data: getContactDetails(item),
                    id: item.id
                }

                MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader, currentStep);
            });
            MLTagManagerService.sendFormStepPolicyChangeStep();
            const newStepID = 'endorsementAdditionalChanges';
            MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, productCode);

            if (isAgent) {
                PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                    step: 'PolChange Interested Parties Screen',
                    action: 'Interested Parties Submitted'
                });
            }
        } else {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
        }
        
    }, [authHeader, changeNextSteps, currentStep, currentStepIndex, errorTimestamp, getAdditionalInterests, getAutoInterests, goNext, isAgent, productCode, steps, submissionVM, translator]);

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values={{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    }; 

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardSubmissionData(newSubmissionVM);
    }, [submissionVM, updateWizardSubmissionData, viewModelService]);

    const updateSubmissionVM = useCallback(() => { 
        _.set(wizardData, 'submissionVM', submissionVM);
        updateWizardData(wizardData);
    }, [submissionVM, updateWizardData, wizardData]);

    const generateVehiclesOverrides = useCallback(() => {
        if (isPersonalAuto) {
            const overrides = vehicles.map((vehicle, index) => {
                return {
                    [`vehicleAdditionalInterestsComponent${index}`]: {
                        vehicleVM: vehicle,
                        index,
                        onValueChange: writeValue,
                        updateViewModel: updateSubmissionVM,
                        initialPotentialContact: potentialContacts,
                        showValidationErrors: showErrors,
                        onValidate,
                        isHOLine: isHomeowners,
                        isPersonalUmbrella,
                        potentialContactsLoading,
                        currentStepName: currentStep.mlStepName,
                        endorsementVM: submissionVM,
                        additionalInterestAvailableCandidatesML
                    }
                };
            });
            
            return Object.assign({ 
                additionalInterestList: {
                    visible: false
                }
            }, ... overrides);
        }
    }, [additionalInterestAvailableCandidatesML, currentStep.mlStepName, isHomeowners, isPersonalAuto, isPersonalUmbrella, onValidate, potentialContacts, potentialContactsLoading, showErrors, submissionVM, updateSubmissionVM, vehicles, writeValue]);

    const generateHOAndPUPOverrides = useCallback(() => {
        if (!isPersonalAuto) {
            const overrides = {
                additionalInterestList: {
                    model: getAdditionalInterests(),
                    addressVM,
                    updateViewModel: updateSubmissionVM,
                    onValueChange: writeValue,
                    path: isHomeowners ? HO_ADDITIONAL_INTERESTS_PATH : PUP_ADDITIONAL_INTERESTS_PATH,
                    initialPotentialContact: potentialContacts,
                    showValidationErrors: showErrors,
                    onValidate,
                    isHOLine: isHomeowners,
                    isRenters,
                    isPersonalUmbrella,
                    coveragePartTypeML,
                    potentialContactsLoading,
                    policyChangePaymentMethod: _.get(submissionVM, 'paymentDetails_ML.ratingPaymentMethod_ML.value.code', ''),
                    currentStepName: currentStep.mlStepName,
                    additionalInterestAvailableCandidatesML,
                    submissionVM
                }
            };
    
            return overrides;
        }
    }, [additionalInterestAvailableCandidatesML, currentStep.mlStepName, getAdditionalInterests, isHomeowners, isPersonalAuto, isPersonalUmbrella, isRenters, onValidate, potentialContacts, potentialContactsLoading, showErrors, submissionVM, updateSubmissionVM, writeValue]);

    const getNamedNonOwnerLabel=()=>{
        return isModernProduct ? translator(messages.namedNonOwnerHeadingNP):translator(messages.namedNonOwnerHeading)
    }
    
    const resolvers = {
        resolveCallbackMap: {
            onNext: onNext
        },
        resolveComponentMap: {
            mloutofsequenceconflictcomponent: MLOutOfSequenceConflictComponent,
            vehicleadditionalinterestscomponent: VehicleAdditionalInterestsComponent
        }
    };
    const overrideProps = {
        pageContainer: {
            className: isAgent ? 'page-content-gpa' : ''
        },
        oosComponent: {
            isOOSConflict,
            isAgent
        },
        namedNonOwnerContainer: {
            visible: hasNamedNonOwner()
        },
        namedNonOwnerHeader: {
            visible: isAgent,
            content:getNamedNonOwnerLabel()
        },
        paVehicleInfoIterable: {
            visible: !hasNamedNonOwner() && isPersonalAuto,
            data: vehicles,
        },
        nextDescription: {
            content: getNextStepText()
        },
        nextButton: {
            disabled: isOOSConflict
        },
        stickyContinueSection: {
            visible: isAgent,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            disableNext: isOOSConflict,
            onNext
        },
        ... generateVehiclesOverrides(),
        ... generateHOAndPUPOverrides()
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={isAgent ? messages.makeChanges : messages.updateInterestdParties}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                model={submissionVM}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

export default withAuthenticationContext(InterestedPartiesPage);